import {
  Button,
  Container,
  createStyles,
  Grid,
  IconButton,
  List,
  makeStyles,
  Paper,
  Theme,
  Typography,
} from '@material-ui/core';
import React, { FC, Fragment, useEffect, useState } from 'react';
import {
  GalleryImage,
  HasEvent,
  LocationData,
  LocationDeviceAndGal,
  Devices,
  PostUpdateDeviceParams,
} from '../../../api/infomodul/models';
import * as infomodul from '../../../api/infomodul';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import CheckIcon from '@material-ui/icons/Check';
import RemoveFromQueueIcon from '@material-ui/icons/RemoveFromQueue';
import EditFrontView from './EditFrontView';
import APIRequest from '../../helpers/APIRequest';
import PendingDialog from '../../dialogs/PendingDialog';
import FormDialog from '../../dialogs/FormDialog';
import CreateEvent from '../../dialogs/formDialogs/CreateEvent';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
import ErrorDialog from '../../dialogs/ErrorDialog';

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     fullHeight: {
//       height: '100%',
//     },
//     tabs: {
//       borderRight: `1px solid ${theme.palette.divider}`,
//     },
//     maxParent: {
//       maxWidth: '100%',
//       maxHeight: '10rem',
//     },
//     paper: {
//       marginBottom: '1.5rem',
//     },
//     iconText: {
//       fontSize: '15px',
//     },
//   })
// );

const useStyles = makeStyles((theme: Theme) => createStyles({
  fullHeight: {
    height: '100%',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  maxParent: {
    maxWidth: '13rem',
    maxHeight: '10rem',
  },
  paper: {
    marginBottom: '1.5rem',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  iconText: {
    fontSize: '15px',
  },
}));

interface Props {
  selectedDevices: number[];
  selectedDevicesIds: number[];
  galleryData: GalleryImage[];
  deviceData: Devices[];
  eventData: HasEvent[];
  locationData: LocationDeviceAndGal;
  selectedTab: number;
  selectedLocation: LocationData | undefined;
  setDeviceBoxDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  setUpdateOnDeviceBoxChange: React.Dispatch<React.SetStateAction<boolean>>;
  updateOnDeviceBoxChange: boolean;
  setRunGetGalleryImages: React.Dispatch<React.SetStateAction<boolean>>;
  setRunGetEventInfo: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedDeviceIds: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedDevices: React.Dispatch<React.SetStateAction<number[]>>;
}

const FrontView: FC<Props> = ({
  selectedDevices,
  selectedDevicesIds,
  galleryData,
  deviceData,
  eventData,
  locationData,
  selectedTab,
  selectedLocation,
  setDeviceBoxDisabled,
  setUpdateOnDeviceBoxChange,
  updateOnDeviceBoxChange,
  setRunGetGalleryImages,
  setRunGetEventInfo,
  setSelectedDeviceIds,
  setSelectedDevices,
 
}) => {
  const classes = useStyles();

  const [edit, setEdit] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [runDeleteEvent, setRunDeleteEvent] = useState(false);
  const [runUpdateDevice, setRunUpdateDevice] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorUpdateNowOpen, setErrorUpdateNowOpen] = useState(false);
  const [runDefault, setRunDefault] = useState(false);
  const [runRemoveActive, setRunRemoveActive] = useState(false);
  const [runRemoveActiveDialogue, setRunRemoveActiveDialogue] = useState(false);
  const [runUpdateNowDialogue, setRunUpdateNowDialogue] = useState(false);
  const [runSetAsStandard, setRunSetAsStandard] = useState(false);

  const [createEventOpen, setCreateEventOpen] = React.useState(false);
  const [runActiveEvents, setActiveEvents] = useState(false);
  const [startDate, setStartDate] = useState(Date);
  const [endDate, setEndDate] = useState(Date);
  const [seletedImageId, setSeletedImageId] = React.useState<number>();
  const [imgName, setImgName] = useState<string>();
  const [devicesForEvent, setDevicesForEvent] = useState<string[] | undefined>(
    []
  );
  const [apiError, setApiError] = useState(false);
  const [apiErrorText, setApiErrorText] = useState<string>('');
  const [apiErrorTitle, setApiErrorTitle] = useState<string>('');

  useEffect(() => {
    if (!edit) {
      setDeviceBoxDisabled(true);
      setSelectedDeviceIds([]);
    }
  }, [edit, setDeviceBoxDisabled, updateOnDeviceBoxChange, selectedTab,setSelectedDeviceIds]);

  //Post event to database
  const PostEvent = () => {
    return (
      <Fragment>
        {seletedImageId && imgName && (
          <APIRequest<any>
            run={runActiveEvents}
            setRun={setActiveEvents}
            pending={isPending}
            setIsPending={setIsPending}
            req={() =>
              infomodul.createEvent({
                imgName: imgName,
                body: {
                  Start: startDate,
                  Stop: endDate,
                  GalleryID: locationData.galleries[selectedTab].id,
                  GalleryImageID: seletedImageId,
                  clientHash: devicesForEvent,
                },
              })
            }
            setData={() => {
              setRunGetEventInfo(true);
              setActiveEvents(false);
              setDevicesForEvent([]);
              setImgName(undefined);
            }}
            setShowError={() => {
              setApiError(true);
    
            }}
            storeError={(error) => {
              setApiErrorTitle('Fejl - kunne ikke oprette event')
              setApiErrorText('Tjek om du har valgt gyldig start og slut dato. Tjek at der ikke allerede er et aktivt slideshow på den valgte automat - Og prøv igen')
            }}
          />
        )}
      </Fragment>
    );
  };

  //Delete event and remove it from database
  const DeleteEvent = () => {
    return (
      <Fragment>
        {seletedImageId && (
          <APIRequest<any>
            run={runDeleteEvent}
            setRun={setRunDeleteEvent}
            pending={isPending}
            setIsPending={setIsPending}
            req={() =>
              infomodul.deleteEvent({
                imageId: seletedImageId,
              })
            }
            setData={() => {
              setRunGetEventInfo(true);
            }}
          />
        )}
      </Fragment>
    );
  };

  //Set image as default
  const SetDefault = () => {
    return (
      <Fragment>
        {seletedImageId && (
          <APIRequest<any>
            run={runDefault}
            setRun={setRunDefault}
            pending={isPending}
            setIsPending={setIsPending}
            req={() =>
              infomodul.setDefault({
                imageId: seletedImageId,
              })
            }
            setData={() => {}}
          />
        )}
      </Fragment>
    );
  };

  //Force an update on a device
  const ForceUpdateDevice = () => {
    return (
      <APIRequest<PostUpdateDeviceParams>
        run={runUpdateDevice}
        setRun={setRunUpdateDevice}
        pending={isPending}
        setIsPending={setIsPending}
        req={() =>
          infomodul.DeviceUpdateNow({
            body: {
              deviceid: selectedDevicesIds,
              masterPort: locationData.devices[0].masterPort
            },
          })
        }
        setData={() => {}}
      />
    );
  };

  //Remove image from active instead of completely deleting it
  const RemoveActive = () => {
    return (
      <Fragment>
        {seletedImageId && (
          <APIRequest<any>
            run={runRemoveActive}
            setRun={setRunRemoveActive}
            pending={isPending}
            setIsPending={setIsPending}
            req={() =>
              infomodul.RemoveActive({
                imgId: seletedImageId,
                body: {
                  clientHash: getClientHashes(selectedDevicesIds),
                },
              })
            }
            setData={() => {}}
          />
        )}
      </Fragment>
    );
  };

  function getClientHashes(devIds: number[]) {
    let clientHashes: string[] = [];
    for (let index = 0; index < devIds.length; index++) {
      const element = deviceData.find(
        (element) => element.deviceNumber === devIds[index]
      );
      if (element !== undefined) {
        clientHashes.push(element.clientHash);
      }
    }
    return clientHashes;
  }

  //Changes date string to a more readable string
  function changeDateString(date: string) {
    let dString: string;
    let dateObj: Date = new Date(date);
    dString = ` ${dateObj.getDate()}/${
      dateObj.getMonth() + 1
    }/${dateObj.getFullYear()}`;

    return dString;
  }

  //For displaying eventinfo on the individual image
  function EventInfo(img: GalleryImage) {
    const found = eventData.find((value) => {
      return value.galleryImageId === img.id;
    });
    if (found?.start === undefined) {
      return <div>Intet aktivt event</div>;
    } else {
      return (
        <div>
          Start dato:
          {found && changeDateString(found.start)}
          <div>
            Slut dato:
            {found && changeDateString(found.stop)}
          </div>
        </div>
      );
    }
  }

  function TypeInfo(type: string) {
    switch (type) {
      case 'udeafdrift':
        return 'Type: Ude af drift';
      case 'pauseskaerm':
        return 'Type: Pauseskærm';
      case 'reklame':
        return 'Type: Reklame';
    }
  }

  return (
    <Fragment>
      <PostEvent />
      <DeleteEvent />
      <ForceUpdateDevice />
      <SetDefault />
      <RemoveActive />
      {edit ? (
        <EditFrontView
          galleryData={galleryData}
          locationData={locationData}
          deviceData={deviceData}
          eventData={eventData}
          selectedDevices={selectedDevices}
          selectedDeviceIds={selectedDevicesIds}
          setEdit={setEdit}
          selectedTab={selectedTab}
          setDeviceBoxDisabled={setDeviceBoxDisabled}
          setUpdateOnDeviceBoxChange={setUpdateOnDeviceBoxChange}
          setRunGetGalleryImages={setRunGetGalleryImages}
          setSelectedDeviceIds={setSelectedDeviceIds}
          setSelectedDevices={setSelectedDevices}

        />
      ) : (
        <Grid container spacing={2}>
          <Container maxWidth={false} style={{ backgroundColor: '#ffffff', marginTop: '25px', paddingTop: '18px' }}>
          <Grid item xs={12}>
            <Typography component="h2" variant="h5" style={{ textAlign: 'center' }}>
              <b>Begivenhedsoversigt:</b>
            </Typography>
          </Grid>

          <Container maxWidth="xs" style={{ textAlign: 'center', marginBottom: '20px' }}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setEdit(true);
                  }}
                >
                  Rediger
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setCreateEventOpen(true);
                  }}
                >
                  Opret Automatbegivenhed
                </Button>
              </Grid>
              {/* <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    if (selectedDevicesIds.length !== 0) {
                      setRunUpdateNowDialogue(true);
                    } else {
                      setErrorUpdateNowOpen(true);
                    }
                  }}
                >
                  Opdater nu
                </Button>
              </Grid> */}
            </Grid>
          </Grid>
          </Container>
          <Container maxWidth={false}>
          <Grid style={{overflowY: 'scroll', maxHeight: "92vh", overflowX: 'hidden', width: '100%'}}>
          <Grid item xs={12}>
            <List>
              {galleryData.length > 0 ? (
                <Fragment>
                  {galleryData.map((value, i) => {
                    // const labelId = `checkbox-list-label-${value}`;
                    return (
                      <Paper key={i} className={classes.paper}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={5} >
                            <Typography component="h3" variant="h5">
                              {value.imgDescription}
                            </Typography>
                            <Typography component="p">
                              {TypeInfo(value.type)}
                            </Typography>
                            <Typography component="div">
                              {EventInfo(value)}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={5}>
                            <img
                              src={`${infomodul.baseUrl()}/image/${
                                value.imgName
                              }`}
                              className={classes.maxParent}
                              alt={value.imgName}
                            ></img>
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <div style={{textAlign: 'left'}}>
                            <Fragment>
                              <IconButton
                                aria-label="delete"
                                onClick={() => {
                                  setSeletedImageId(value.id);
                                  setDeleteOpen(true);
                                }}
                              >
                                <EventBusyIcon />
                                <div className={classes.iconText}>
                                  Slet Begivenhed
                                </div>
                              </IconButton>
                              <IconButton
                                aria-label="defaultSet"
                                onClick={() => {
                                  setSeletedImageId(value.id);
                                  setRunSetAsStandard(true);
                                }}
                              >
                                <CheckIcon />
                                <div className={classes.iconText}>
                                  Sæt som standard
                                </div>
                              </IconButton>
                              {/* <IconButton
                                aria-label="removeActive"
                                onClick={() => {
                                  setSeletedImageId(value.id);
                                  setRunRemoveActiveDialogue(true);
                                }}
                              >
                                <RemoveFromQueueIcon />
                                <div className={classes.iconText}>
                                  Deaktiver billedet
                                </div>
                              </IconButton> */}
                            </Fragment>
                            </div>
                          </Grid>
                        </Grid>
                      </Paper>
                    );
                  })}
                </Fragment>
              ) : (
                <div>Ingen data valgt</div>
              )}
            </List>
          </Grid>
          </Grid>
          </Container>

          <FormDialog
            title={'Opret Automat Begivenhed'}
            open={createEventOpen}
            onCloseCancel={() => {
              setCreateEventOpen(false);
              setDevicesForEvent([]);
              setImgName(undefined);
            }}
            onCloseSubmit={() => {
              if (imgName !== undefined && devicesForEvent?.length !== 0) {
                setActiveEvents(true);
                setCreateEventOpen(false);
              } else {
                setErrorOpen(true);
              }
            }}
          >
            <CreateEvent
              galleryData={galleryData}
              deviceData={deviceData}
              StartDate={setStartDate}
              EndDate={setEndDate}
              selectedImageId={setSeletedImageId}
              imgName={setImgName}
              devicesForEvent={setDevicesForEvent}
            />
          </FormDialog>

          <ErrorDialog
            open={errorOpen}
            onClose={function (): void {
              setErrorOpen(false);
            }}
            title={'Forkert input'}
            text={'Husk at udfylde alle felter'}
          />

          <ErrorDialog
            open={errorUpdateNowOpen}
            onClose={function (): void {
              setErrorUpdateNowOpen(false);
            }}
            title={'Ingen valgte automater'}
            text={'Husk at vælge de automater der skal opdateres'}
          />

            <ErrorDialog
              open={apiError}
              onClose={function (): void {
                setApiError(false);
              }}
              title={apiErrorTitle}
              text={apiErrorText}
            />

          <ConfirmDialog
            title={'Sikker på at du vil slette denne Begivenhed?'}
            text={'Slet'}
            open={deleteOpen}
            onConfirm={() => {
              setRunDeleteEvent(true);
              setDeleteOpen(false);
            }}
            onClose={() => setDeleteOpen(false)}
          />

          <ConfirmDialog
            title={'Sikker på at du vil deaktivere billedet?'}
            text={'Deaktiver'}
            open={runRemoveActiveDialogue}
            onConfirm={() => {
              setRunRemoveActive(true);
              setRunRemoveActiveDialogue(false);
            }}
            onClose={() => setRunRemoveActiveDialogue(false)}
          />

          <ConfirmDialog
            title={'Sikker på at du vil opdatere automaterne?'}
            text={'Opdater'}
            open={runUpdateNowDialogue}
            onConfirm={() => {
              setRunUpdateDevice(true);
              setRunUpdateNowDialogue(false);
            }}
            onClose={() => setRunUpdateNowDialogue(false)}
          />

          <ConfirmDialog
            title={'Sikker på at du vil sætte dette billede som standard?'}
            text={'Sæt som standard'}
            open={runSetAsStandard}
            onConfirm={() => {
              setRunDefault(true);
              setRunSetAsStandard(false);
            }}
            onClose={() => setRunSetAsStandard(false)}
          />
          </Container>
        </Grid>
      )}
      <PendingDialog open={isPending} title={'Loading'} />
    </Fragment>
  );
};

export default FrontView;
